import { Field, Fields } from "redux-form";

import { Grid, Typography } from "@braintrust/braintrust-ui-components";
import { InfoIcon } from "@braintrust/braintrust-ui-components/Icons";
import { InvoiceNumberField } from "@js/apps/invoices/fields/invoice-number-field";
import { IssuedAtField } from "@js/apps/invoices/fields/issued-at-field";
import { SelectJobField } from "@js/apps/invoices/fields/select-job-field";

import { EmployerAddress } from "../employer-address";

import styles from "./style.module.scss";

type HeaderProps = {
  canChangeJob: boolean;
  isCopy: boolean;
  isEdit?: boolean;
  isExpenseOnlyInvoiceForm: boolean;
};

export const Header = ({
  canChangeJob,
  isCopy,
  isEdit,
  isExpenseOnlyInvoiceForm,
}: HeaderProps) => {
  return (
    <div className={styles.invoiceHead}>
      <Grid container spacing={4} sx={{ justifyContent: "space-between" }}>
        {isExpenseOnlyInvoiceForm && (
          <Grid
            size={{
              xs: 12,
            }}
          >
            <Typography
              variant="paragraph"
              size="large"
              component="p"
              sx={{ mb: 1 }}
            >
              <InfoIcon
                sx={{ fontSize: "25px", mr: 1, verticalAlign: "sub" }}
              />
              This is an Expense Only Invoice. Services must be invoiced
              separately.
            </Typography>
          </Grid>
        )}
        <Grid
          size={{
            xs: 12,
            md: 7,
          }}
        >
          <Grid container spacing={4}>
            <Grid
              size={{
                xs: 12,
                sm: 8,
              }}
            >
              <Fields
                names={["job", "employer"]}
                component={SelectJobField}
                canChangeJob={canChangeJob}
                isCopy={isCopy}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 4,
              }}
              className="posr"
            >
              <Field
                isEdit={isEdit}
                id="number"
                name="number"
                component={InvoiceNumberField}
              />
            </Grid>
            <Grid
              size={{
                sm: 6,
                md: 5,
                lg: 4,
              }}
            >
              <Field name="issued_at" component={IssuedAtField} />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
          className={styles.invoiceHeadEmployersAddress}
        >
          <Field name="job" component={EmployerAddress} />
        </Grid>
      </Grid>
    </div>
  );
};
